module.exports = __webpack_public_path__ + "static/projekt-refresh-opakowan-vega-cola-b2534636c7cf6163f610f50b916bcaa2.jpg";